module.exports = __webpack_public_path__ + "img/pre_intro.6ffa39a8.png";